import React from 'react'
import { ComingSoon } from '../../../components/ComingSoon'

export const CarRentalPage = () => {
  return (
    <ComingSoon heading="Car Rental">
      <div className="text-sm text-gray-500 font-medium mt-4">🚧 Coming Soon Feature</div>
    </ComingSoon>
  )
}
